import http from "./http";

export type StationLandingNotFoundAlertConfig = {
	enabled: boolean;
	recipientEmails: string;
	dedupeSeconds: number;
	updatedAt?: string;
};

const DEFAULTS: StationLandingNotFoundAlertConfig = {
	enabled: false,
	recipientEmails: "",
	dedupeSeconds: 3600,
};

export async function getStationLandingNotFoundAlertConfig(): Promise<StationLandingNotFoundAlertConfig> {
	const { data } = await http.get("/utility/station-landing-not-found-alert-config");
	return { ...DEFAULTS, ...(data?.data || {}) };
}

export async function saveStationLandingNotFoundAlertConfig(
	config: StationLandingNotFoundAlertConfig,
): Promise<{ message?: string }> {
	const { data } = await http.post("/utility/station-landing-not-found-alert-config", {
		data: config,
	});
	return data || {};
}
